/* eslint-disable react/jsx-no-undef */
import React, { Component } from 'react';
import { Layout, Alert, Button } from 'antd';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { PricingConsentModal, SoftLockModal } from '../../components/Common';
import './index.scss';
import { handleApiExceptions, getIndianRupeeNotation, alertify } from '../../app_methods';
import { MerchantService } from '../../services';
import { updateCurrentUserAction } from '../../redux/actions';
import NavBar from './NavBar';
import NewSidebar from '../../components/Common/Newsidebar/NewSidebar';
import { primaryMenu } from '../../components/Common/Newsidebar/primary-menu.config';
import { SmartCollectTransaction } from '../../models';

const { Content } = Layout;

class AppLayout extends Component {
	redirect = this.props.redirect.bind(this);
	toggleSidebar = this.toggleSidebar.bind(this);
	onChildMount = this.onChildMount.bind(this);
	fetchMerchantInfo = this.fetchMerchantInfo.bind(this);
	togglePricingConsentModal = this.togglePricingConsentModal.bind(this);
	updateConsent = this.updateConsent.bind(this);
	toggleSoftLockModal = this.toggleSoftLockModal.bind(this);

	state = {
		sidebarCollapsed: isMobile ? true : false,
		activeSidebar: [],
		isFetching: false,
		isRedirecting: false,
		showPricingConsentModal: !this.props.current_user.pricing_consent,
		isUpdatingConsent: false,
		showSoftLockModal: false,
	}

	toggleSidebar() {
		if (isMobile) this.setState({ sidebarCollapsed: !this.state.sidebarCollapsed })
	}

	togglePricingConsentModal(flag) {
		this.setState({ showPricingConsentModal: flag })
	}

	toggleSoftLockModal() {
		this.setState({ showSoftLockModal: !this.state.showSoftLockModal })
	}

	onChildMount(pathkey) {
		const merchant_id = !this.props.current_user.is_submerchant ? this.props.current_user.eid : `WID-${this.props.current_user.parent_merchant_easebuzz_id}-${this.props.current_user.id}`
		const page = this.props.children.props.pathkey.toUpperCase()
		let user_data = { "Name": merchant_id, "Email": merchant_id + "@easebuzz.in", "Page": "WIRE-" + page }
		if (this.props.children.props.pathkey == "insta-collect") {
			user_data = { "Name": merchant_id, "Email": merchant_id + "@easebuzz.in", "Page": page }
		}
		try {
			if (window.surveysensum != undefined) {
				window.surveysensum.setUserInfo(user_data)
				if (process.env.REACT_APP_ENV === 'prod') {
					window.surveysensum.startSurvey('prod-wire', { "vz7": user_data.Page })
				} else {
					window.surveysensum.startSurvey('dev-wire', { "vz7": user_data.Page })
				}
			}
		}
		catch (err) {
			console.log("nps surveysensum object not found.")
		}
		this.setState({
			activeSidebar: [pathkey || this.props.children.props.pathkey],
			showPricingConsentModal: !this.props.current_user.pricing_consent,
			showSoftLockModal: this.props.current_user.soft_lock
		});
	}

	fetchMerchantInfo() {
		this.setState({ isFetching: true });
		MerchantService.fetch().then((response) => {
			console.log(response);
			if (response.success) this.props.updateCurrentUser(response.data.merchant);
			this.setState({ isFetching: false });
		}).catch((error) => {
			handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
			this.setState({ isFetching: false });
		})
	}

	redirectURL =async()=> {
		this.setState({ isRedirecting: true });
		const response = await SmartCollectTransaction.redirect_to_drs()
        if (!response.success) {
			this.setState({ isRedirecting: false });
            alertify("Couldn't Redirect", response.message, "warning");
            return;
        }
        window.open(response.data.url, '_blank')
		this.setState({ isRedirecting: false });
	}

	updateConsent() {
		this.setState({ isUpdatingConsent: true });
		MerchantService.updateConsent({ 'accepted': true }).then((response) => {
			if (response.success) {
				this.setState({ showPricingConsentModal: false });
				this.fetchMerchantInfo();
			}
			this.setState({ isUpdatingConsent: false });
		}).catch((error) => {
			handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
			this.setState({ isUpdatingConsent: false });
		})
	}


	render() {
		const props = this.props;
		const virtual_account = props.current_user.virtual_account || {};
		const balanceObj = getIndianRupeeNotation(virtual_account.balance || 0, 3);

		const logout = () => {
			// setLoggingOut(true);
			MerchantService.logout().then(response => {
				if (response.data.success) {
					let url = "";
					if (props.current_user.is_easebuzz_merchant && props.current_user.user.is_admin) {
						url = `${process.env.REACT_APP_AUTH_URL}easebuzz/login?next=${encodeURI(process.env.REACT_APP_AUTH_REDIRECT_URL)}`;
					}
					else if (props.current_user.is_submerchant || !props.current_user.user.is_admin) {
						url = props.current_user.white_label_setting.login_url;
					}
					window.location.replace(url);
				}
				else {
					handleApiExceptions("Something went wrong.");
				}
				// setLoggingOut(false);
			}).catch(error => {
				handleApiExceptions(error);
				// setLoggingOut(false);
			});
		};
		return (
			<div className="app-layout-container h-100">
				<div className="app-layout-body h-100">
					<Layout>
						<NewSidebar merchant={props.current_user} logout={logout} menu={primaryMenu(props.current_user,this.redirectURL)} />
						<div className="app-layout-content-wrapper" style={this.state.sidebarCollapsed ? styles.layoutInnerCollapsed : styles.layoutInner}>
							{/* <Navbar toggleSidebar={this.toggleSidebar} sidebarCollapsed={this.state.sidebarCollapsed} redirect={props.redirect} /> */}
							<Content style={styles.content}>
								<NavBar
									redirect={this.redirect}
									activeSidebar={this.state.activeSidebar}
									toggleSidebar={this.toggleSidebar}
									sidebarCollapsed={this.state.sidebarCollapsed}
									logout={logout}
								/>
								{props.current_user.cbe && <Alert
									type="info"
									className="mb-2"
									message="Important Notification - Connected Banking"
									showIcon
									closable
									description={
										<div>
											 Kindly use connected banking account to process transfers. Your API credentials have been sent across to your registered email ID.
										</div>
									}
								/>}
								{
									props.current_user.itm ? (
										<Alert
											type="info"
											className="mb-2"
											message="Test Mode"
											showIcon
											style={{ borderRadius: 10 }}
											description={<div>Your account is currently in test mode. Maximum amount allowed per transaction is ₹ {props.current_user.test_mode_spec.TEST_MODE_MAX_AMOUNT_PER_TXN}/- and Maximum total transaction amount allowed is ₹ {props.current_user.test_mode_spec.TEST_MODE_MAX_AMOUNT_TOTAL}/-.<br /> You will not be charged any fees while test mode is on.</div>}
										/>
									) : null
								}
								{React.cloneElement(props.children, {
									onChildMount: this.onChildMount
								})}
							</Content>
						</div>
					</Layout>
					{props.current_user ? <PricingConsentModal
						visible={this.state.showPricingConsentModal}
						current_user={props.current_user}
						isUpdatingConsent={this.state.isUpdatingConsent}
						onAccept={this.updateConsent}
					/> : null}
					{
						props.current_user ?
							<SoftLockModal
								visible={this.state.showSoftLockModal}
								merchant={props.current_user}
								postAuthentication={() => {
									this.toggleSoftLockModal();
									this.fetchMerchantInfo();
								}}
							/> : null
					}

				</div>
			</div>
		)
	}
}

const styles = {
	layoutInnerCollapsed: {
		marginLeft: 0,
		transition: 'all .2s',
		WebkitTransition: 'all .2s'
	},
	layoutInner: {
		// marginLeft: isMobile ? 0 : 225,
		transition: 'all .2s',
		WebkitTransition: 'all .2s'
	},
	content: {
		padding: '16px 16px 0',
		overflow: 'initial',
		// marginTop: 48
	}
}

const mapStateToProps = state => ({
	current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
	updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);